export const UpTags = {
  1: {
    cl: 'pf',
    label: 'Pretty Face',
    val: 1
  },
  2: {
    cl: 'ga',
    label: 'Good Attitude',
    val: 2
  },
  3: {
    cl: 'talk',
    label: 'Talkative',
    val: 3
  },
  4: {
    cl: 'ee',
    label: 'Excellent Experience',
    val: 4
  },
  5: {
    cl: 'av',
    label: 'Attractive Voice',
    val: 5
  },
  6: {
    cl: 'abf',
    label: 'Amazing Body Figure',
    val: 6
  }
}

export const DwnTags = {
  1: {
    cl: 'fp',
    label: 'Fake photos',
    val: 1
  },
  2: {
    cl: 'ba',
    label: 'Bad Attitude',
    val: 2
  },
  3: {
    cl: 'pl',
    label: 'Poor Languages',
    val: 3
  },
  4: {
    cl: 'bs',
    label: 'Glitches(Black Screen)',
    val: 4
  },
  5: {
    cl: 'bc',
    label: 'Bad conditions(noisy/blurred)',
    val: 5
  },
  6: {
    cl: 'ot',
    label: 'Others',
    val: 6
  }
}

export const UserType={
  ANCHOR:0,
  USER:1
}

export const RoomType={
    multi : 1,                     // 语聊房
    o2m : 3                       // 1对多直播间
}

/*{
  PrettyFace = 1,                // Pretty Face
  TBYLikeTagGoodAttitude = 2,          // Good Attitude/Behaviors
  TBYLikeTagTalkative = 3,             // Talkative
  TBYLikeTagAmazingPerformance = 4,    // Amazing Performance
  TBYLikeTagAttractiveVoice = 5,       // Attractive Voice
  TBYLikeTagGoodBodyFigure = 6,        // Good Body Figure
}*/




// WEBPACK FOOTER //
// ./src/const/Tags.js